import { StyleSheet, View } from 'react-native'
import { BaseModalConfig } from '..'
import { DS } from '../../../../../design-system'
import { BottomModalButton } from '../../../BottomModalContent/BottomModalButton'

export interface ThreeCardLeaveConfirmProps extends BaseModalConfig {
  onLeave: () => void
}

export const ThreeCardLeaveConfirm = ({ onClose, onLeave }: ThreeCardLeaveConfirmProps) => {
  return (
    <View style={styles.container}>
      <DS.Text variant="Heading 2/Medium" textAlign="center">
        Are you sure you want to leave?
      </DS.Text>
      <DS.Text variant="Body Medium/Regular" textAlign="center">
        Your progress won't be saved and you'll have to wait until tomorrow to play again.
      </DS.Text>
      <View style={styles.buttons}>
        <BottomModalButton
          text="No, don't leave"
          onPress={onClose}
          size="large"
          textStyle={[{ ...DS.typography['Body Medium/Medium'], color: DS.palette['Global/White'] }]}
        />
        <BottomModalButton
          text="Yes, leave game"
          onPress={onLeave}
          size="large"
          alternateColor
          textStyle={[{ ...DS.typography['Body Medium/Medium'] }]}
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 15,
    gap: 15
  },
  buttons: {
    gap: 5
  }
})
